function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from "sprout-ui-primitives";
import { UserType } from "sprout-graphql";
import imageCache from "sprout-lib/dist/image-cache";
import { PeopleOutlined } from "sprout-ui-icons";
import { Image } from "sprout-ui-dom/dist/Image";
import { Link } from "react-router-dom";
import styled from "styled-components";
const StyledFlex = styled(Flex)`
  position: relative;
`;
const StyledImage = styled(Image)`
  object-fit: cover;
  object-position: center;
  line-height: ${({ $size  })=>$size}px;
`;
const Loader = styled.div`
  position: absolute;
  top: 10%;
  left: 10%;
  right: 10%;
  bottom: 10%;
  border: 16px solid rgba(200, 200, 200, 0.8);
  border-top: 16px solid rgba(52, 152, 219, 0.8);
  border-radius: 50%;
  animation: spin 2s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
const Avatar = (props)=>{
    const { size =24 , user , navigable , className , uploading  } = props;
    const { avatar , gravatar , username , type  } = user;
    const highDPIsize = size * 4;
    let src;
    if (avatar) src = imageCache(avatar, {
        w: highDPIsize
    });
    else if (type === UserType.User && gravatar) src = `https://www.gravatar.com/avatar/${gravatar}?s=${highDPIsize}&d=mm`;
    const as = _objectSpread({}, navigable && {
        as: Link,
        to: `/${username}`
    });
    return /*#__PURE__*/ _jsxs(StyledFlex, _objectSpread({
        as: "span",
        width: size,
        height: size,
        alignItems: "center",
        justifyContent: "center",
        color: "black.60",
        borderRadius: "50%",
        bg: "grey.100",
        className: className
    }, as, {
        children: [
            src && /*#__PURE__*/ _jsx(StyledImage, {
                src: src,
                height: "100%",
                alt: `@${username}`,
                $size: size
            }),
            type === UserType.Team && !src && /*#__PURE__*/ _jsx(PeopleOutlined, {}),
            uploading ? /*#__PURE__*/ _jsx(Loader, {}) : null
        ]
    }));
};
export default Avatar;
